module.exports = __webpack_public_path__ + "static/img_1830-02f6794c58f8c57fa5b98a98dc6b3b21.webp";